/**
 * `user@example.com` -> `u***@example.com`.
 *
 * Экран подтверждения кода показывает адрес замаскированным (MVP_PRD §8): он
 * должен подтвердить получателю, что письмо ушло именно ему, но не выдавать
 * адрес целиком тому, кто просто смотрит на чужой экран.
 */
export function maskEmail(email: string): string {
  const [local, domain] = email.split('@');
  if (!local || !domain) return email;
  return `${local[0] ?? ''}***@${domain}`;
}
